<template>
  <table class="table table-border">
    <thead>
    <tr>
      <th v-for="t in thead">{{t}}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="t in tbody">
      <td>{{t}}</td>
    </tr>
    </tbody>
    <tfoot>

    </tfoot>
  </table>
</template>

<script>
  export default {
    props: ['thead', 'tbody', 'tfoot']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Yazdir/TableYazdir.vue